<app-dialog #modal [dialogWithInput]="dialog">
  <app-pdf-preview [blob]="pdfBlob"
                   [displayDownloadButton]="dialog.input.displayDownloadButton"
                   [displayPrintButton]="dialog.input.displayPrintButton"
                   *ngIf="pdfBlob" style="min-width: 850px; display: block;"></app-pdf-preview>
  <div *ngIf="imageBlob" class="text-center">
    <img [src]="safeUrl" style="max-width: 800px; max-height: 800px;"/>
  </div>

  <ng-container dialog-actions>
    <app-button iconName="download" (clickEvent)="download()" *ngIf="pdfBlob || imageBlob"></app-button>
    <app-button iconName="printer" (clickEvent)="print()" *ngIf="pdfBlob || imageBlob"></app-button>
  </ng-container>

</app-dialog>
